// Presentación del catálogo público de planes (§3.4).
//
// Separada del .svelte por lo mismo que estadoPlan.js: acá los componentes
// Svelte no se testean, así que la lógica que se puede equivocar vive donde sí
// se puede probar.
//
// Ojo con la moneda (decisión de negocio #2): se MUESTRA en dólares y se COBRA
// en pesos, y los dos valores los fija el negocio a mano en la tabla. Acá no se
// convierte nada ni se consulta ninguna cotización: el bug que originó la
// decisión era justamente que el front multiplicaba por el dólar del día y MP
// terminaba cobrando otra cosa.

import { vigente } from "./estadoPlan.js";

/**
 * Si esa tarjeta es el plan que la persona YA tiene andando.
 *
 * Sirve para no ofrecerle comprar lo que ya pagó, que es la forma más rápida de
 * que alguien pague dos veces el mismo mes. Se apoya en `vigente` y no en el
 * estado a secas: una suscripción cancelada pero con período por delante sigue
 * siendo el plan de esa persona hasta que termine.
 */
export function esPlanActual(plan, suscripcion) {
    if (!plan || !suscripcion) return false;
    if (!vigente(suscripcion)) return false;
    return suscripcion.planId === plan.id;
}

/** Los planes que se ofrecen: el Gratuito no se "contrata", se tiene. */
export function planesContratables(planes) {
    return (planes ?? []).filter((p) => p.nivel > 0);
}

/** El catálogo ordenado de menor a mayor, que es como se lee una grilla de planes. */
export function ordenarPlanes(planes) {
    return [...(planes ?? [])].sort((a, b) => (a.nivel ?? 0) - (b.nivel ?? 0));
}

/**
 * El precio a mostrar. Si el plan no tiene `precioUsd` cargado devuelve null y
 * la tarjeta no inventa un número — preferimos no mostrar precio antes que
 * mostrar uno equivocado.
 */
export function precioMostrable(plan) {
    if (!plan || plan.precioUsd === null || plan.precioUsd === undefined) return null;
    return Number(plan.precioUsd);
}

/** Las tres líneas de topes de una tarjeta. `null` es sin límite, no cero. */
export function limitesDePlan(plan) {
    if (!plan) return [];
    return [
        { etiqueta: "Animales", valor: textoLimite(plan.maxAnimales) },
        { etiqueta: "Establecimientos", valor: textoLimite(plan.maxEstablecimientos) },
        { etiqueta: "Usuarios", valor: textoLimite(plan.maxUsuarios) },
    ];
}

function textoLimite(n) {
    return n === null || n === undefined ? "Sin límite" : `Hasta ${n}`;
}
